import { initializeApp } from "firebase/app";

// TODO: Replace with your Firebase project's configuration
const firebaseConfig = {
  apiKey: "AIzaSyA2DA5MsrOS29W5haNNRN9qyQqXk2PPJB8",
  authDomain: "fire-studio-pool1992.firebaseapp.com",
  projectId: "fire-studio-pool1992",
  storageBucket: "fire-studio-pool1992.firebasestorage.app",
  messagingSenderId: "1006173569126",
  appId: "1:1006173569126:web:c44f2c70dbfceb9b7eada7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export { app };
